import { render, staticRenderFns } from "./uploadTag.vue?vue&type=template&id=14f15ccc&scoped=true&"
import script from "./uploadTag.vue?vue&type=script&lang=js&"
export * from "./uploadTag.vue?vue&type=script&lang=js&"
import style0 from "./uploadTag.vue?vue&type=style&index=0&id=14f15ccc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f15ccc",
  null
  
)

export default component.exports